export function EntriesIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
      </svg>
    </>
  );
}

export function NoteIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z" />
      </svg>
    </>
  );
}

export function PlantIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M512 32c0 113.6-84.6 207.5-194.2 222c-7.1-53.4-30.6-101.6-65.3-139.3C290.8 46.3 364 0 448 0l32 0c17.7 0 32 14.3 32 32zM0 96C0 78.3 14.3 64 32 64l32 0c123.7 0 224 100.3 224 224l0 32 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160C100.3 320 0 219.7 0 96z" />
      </svg>
    </>
  );
}

export function GoalsIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M560 160A80 80 0 1 0 560 0a80 80 0 1 0 0 160zM55.9 512l325.2 0 75 0 122.8 0c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 196.1 487.8 192 480 192s-15 4.1-19.1 10.7l-48.2 79L286.8 81c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 426.4C3 435.3 0 445.6 0 456.1C0 487 25 512 55.9 512z" />
      </svg>
    </>
  );
}

export function GiveIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5L192 512 32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.8 0 44.9-36c22.7-18.2 50.9-28 80-28l78.3 0 16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l120.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384c0 0 0 0 0 0l-.9 0c.3 0 .6 0 .9 0z" />
      </svg>
    </>
  );
}

export function ExpandIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z" />
      </svg>
    </>
  );
}

export function CloseIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 384 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
      </svg>
    </>
  );
}

export function CancelIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path
          d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
          fill="var(--error)"
        />
      </svg>
    </>
  );
}

export function CheckIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
        fill={props.fill}
      >
        <path
          d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
          fill={props.fill}
        />
      </svg>
    </>
  );
}

export function CheckIconFilled(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
      </svg>
    </>
  );
}

export function UserIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M399 384.2C376.9 345.8 335.4 320 288 320l-64 0c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z" />
      </svg>
    </>
  );
}

export function GoogleLogo(props) {
  return (
    <>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path
          fill="#EA4335"
          d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
        ></path>
        <path
          fill="#4285F4"
          d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
        ></path>
        <path
          fill="#FBBC05"
          d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
        ></path>
        <path
          fill="#34A853"
          d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
        ></path>
        <path fill="none" d="M0 0h48v48H0z"></path>
      </svg>
    </>
  );
}

export function EyeIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" />
      </svg>
    </>
  );
}

export function EyeSlashIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z" />
      </svg>
    </>
  );
}

export function SearchIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
      </svg>
    </>
  );
}

export function AnalyzeIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 384 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z" />
      </svg>
    </>
  );
}

export function MaximizeIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M32 32C14.3 32 0 46.3 0 64l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96z" />
      </svg>
    </>
  );
}

export function MinimizeIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64zM320 320c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0z" />
      </svg>
    </>
  );
}

// These are newly added icons to the SWP

export function HelpIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5-86.1c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3l0 50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6l0-50.1c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L338.7 175c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z" />
      </svg>
    </>
  );
}

export function MegaPhoneIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75l-8.7 0-32 0-96 0c-35.3 0-64 28.7-64 64l0 96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-147.6c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4L480 32zm-64 76.7L416 240l0 131.3C357.2 317.8 280.5 288 200.7 288l-8.7 0 0-96 8.7 0c79.8 0 156.5-29.8 215.3-83.3z" />
      </svg>
    </>
  );
}

export function SettingsIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z" />
      </svg>
    </>
  );
}

export function HomeIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z" />
      </svg>
    </>
  );
}

export function EvaluationIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 384 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z" />
      </svg>
    </>
  );
}

export function LearningModulesIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9l0 28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5l0-24.6c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z" />
      </svg>
    </>
  );
}

export function UmbrellaIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M288 0c17.7 0 32 14.3 32 32l0 17.7C451.8 63.4 557.7 161 573.9 285.9c2 15.6-17.3 24.4-27.8 12.7C532.1 283 504.8 272 480 272c-38.7 0-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C359 299.5 326.7 272 288 272s-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C167 299.5 134.7 272 96 272c-24.8 0-52.1 11-66.1 26.7C19.4 310.4 .1 301.5 2.1 285.9C18.3 161 124.2 63.4 256 49.7L256 32c0-17.7 14.3-32 32-32zm0 304c12.3 0 23.5 4.6 32 12.2l0 114.3c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4l0-114.3c8.5-7.6 19.7-12.2 32-12.2z" />
      </svg>
    </>
  );
}

export function LinkIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z" />
      </svg>
    </>
  );
}

export function DownloadIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 640"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M352 96C352 78.3 337.7 64 320 64C302.3 64 288 78.3 288 96L288 306.7L246.6 265.3C234.1 252.8 213.8 252.8 201.3 265.3C188.8 277.8 188.8 298.1 201.3 310.6L297.3 406.6C309.8 419.1 330.1 419.1 342.6 406.6L438.6 310.6C451.1 298.1 451.1 277.8 438.6 265.3C426.1 252.8 405.8 252.8 393.3 265.3L352 306.7L352 96zM160 384C124.7 384 96 412.7 96 448L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 448C544 412.7 515.3 384 480 384L433.1 384L376.5 440.6C345.3 471.8 294.6 471.8 263.4 440.6L206.9 384L160 384zM464 440C477.3 440 488 450.7 488 464C488 477.3 477.3 488 464 488C450.7 488 440 477.3 440 464C440 450.7 450.7 440 464 440z" />
      </svg>
    </>
  );
}

export function InfoIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
      </svg>
    </>
  );
}

export function FinishFlag(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M32 0C49.7 0 64 14.3 64 32l0 16 69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 279.7c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 384l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-80 0-66L0 64 0 32C0 14.3 14.3 0 32 0zM64 187.1l64-13.9 0 65.5L64 252.6 64 318l48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3l0-63.9 38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1l0-64c13.6 .4 27.2 2.6 40.4 6.4l23.6 6.9 0 66.7-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8l0 71.4c21.8 1.9 43.3 6.7 64 14.4l0-69.8 22.7 6.7c13.5 4 27.3 6.4 41.3 7.4l0-64.2c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12 0-62c-13-3.8-25.8-8.8-38.2-15c-8.2-4.1-16.9-7-25.8-8.8l0 72.4c-13-.4-26 .8-38.7 3.6L128 173.2 128 98 64 114l0 73.1zM320 335.7c16.8 1.5 33.9-.7 50-6.8l14-5.2 0-71.7-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5l0 77.4zm64-149.4l0-70.8c-20.9 6.1-42.4 9.1-64 9.1l0 69.4c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z" />
      </svg>
    </>
  );
}

export function ChevronIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z" />
      </svg>
    </>
  );
}

export function HamburgerIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z" />
      </svg>
    </>
  );
}

export function AwardIcon(props) {
  return (
    <>
      <svg
        width="550"
        height="701"
        viewBox="0 0 550 701"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path
          d="M275 0C202.065 0 132.118 28.9732 80.5461 80.5457C28.9736 132.118 0.000355646 202.065 0.000355646 275V675C-0.0198944 678.797 0.824861 682.55 2.47086 685.972C4.11711 689.392 6.52111 692.395 9.50036 694.75C12.5051 697.088 16.0039 698.707 19.7299 699.487C23.4559 700.267 27.3106 700.187 31.0004 699.25L250 644.25V550C250 543.37 252.635 537.01 257.323 532.323C262.01 527.635 268.37 525 275 525C281.63 525 287.99 527.635 292.678 532.323C297.368 537.01 300 543.37 300 550V645.25L519 700C520.993 700.24 523.008 700.24 525 700C531.63 700 537.99 697.365 542.678 692.677C547.368 687.99 550 681.63 550 675V275C550 202.065 521.028 132.118 469.455 80.5457C417.883 28.9732 347.935 0 275 0Z"
          fill="#FBC02D"
        />
        <path
          d="M0.000355646 275V675C-0.0198944 678.797 0.824861 682.55 2.47086 685.972C4.11711 689.392 6.52111 692.395 9.50036 694.75C12.5051 697.088 16.0038 698.707 19.7298 699.487C23.4558 700.267 27.3106 700.187 31.0003 699.25L250 645V550C249.985 543.662 252.378 537.555 256.693 532.912C261.01 528.272 266.928 525.442 273.25 525V0C200.62 0.46225 131.12 29.6393 79.9264 81.1617C28.7319 132.684 -0.000894354 202.368 0.000355646 275Z"
          fill="#FDD835"
        />
        <path
          d="M446.75 223C445.3 218.555 442.635 214.607 439.058 211.602C435.478 208.597 431.128 206.657 426.5 206L336.5 192.749L296.25 111.249C294.203 107.022 291.008 103.458 287.028 100.964C283.048 98.4695 278.448 97.1465 273.75 97.1465C269.053 97.1465 264.453 98.4695 260.473 100.964C256.493 103.458 253.298 107.022 251.25 111.249L211 192.749L121 206C116.422 206.705 112.129 208.67 108.602 211.675C105.075 214.677 102.452 218.602 101.026 223.012C99.6002 227.42 99.4272 232.137 100.526 236.637C101.625 241.137 103.953 245.245 107.25 248.5L172.25 312L157 401.75C156.08 406.412 156.51 411.24 158.238 415.667C159.963 420.095 162.918 423.94 166.75 426.75C170.533 429.54 175.025 431.207 179.713 431.562C184.4 431.915 189.093 430.94 193.25 428.75L275 385.75L355.5 428.25C359.17 430.01 363.18 430.947 367.25 431C372.46 430.965 377.53 429.305 381.75 426.25C385.63 423.47 388.633 419.64 390.403 415.21C392.175 410.78 392.643 405.937 391.75 401.25L375 312L440 248.5C443.39 245.3 445.82 241.217 447.013 236.712C448.205 232.205 448.115 227.457 446.75 223Z"
          fill="var(--primary)"
        />
        <path
          d="M251.25 111.248L211 192.748L121.001 205.75C116.344 206.427 111.973 208.405 108.391 211.457C104.808 214.507 102.16 218.51 100.751 223C99.4551 227.362 99.3761 231.997 100.522 236.402C101.667 240.81 103.994 244.817 107.251 248L172.25 311.5L157 401.25C156.238 405.835 156.77 410.542 158.538 414.845C160.303 419.145 163.233 422.867 167 425.595C170.765 428.322 175.218 429.945 179.855 430.282C184.493 430.617 189.13 429.655 193.25 427.5L275 385.75V98.4983C270.238 98.1323 265.47 99.1386 261.26 101.398C257.05 103.658 253.578 107.076 251.25 111.248Z"
          fill="var(--secondary)"
        />
        <path
          d="M275 0C202.065 0 132.118 28.9732 80.5461 80.5457C28.9736 132.118 0.000355646 202.065 0.000355646 275V675C-0.0198944 678.797 0.824861 682.55 2.47086 685.972C4.11711 689.392 6.52111 692.395 9.50036 694.75C12.5051 697.088 16.0039 698.707 19.7299 699.487C23.4559 700.267 27.3106 700.187 31.0004 699.25L275 638.25L519 700C520.993 700.24 523.008 700.24 525 700C531.63 700 537.99 697.365 542.678 692.677C547.368 687.99 550 681.63 550 675V275C550 202.065 521.028 132.118 469.455 80.5457C417.883 28.9732 347.935 0 275 0ZM275 50C319.5 50 363.003 63.196 400.003 87.9192C437.005 112.643 465.843 147.783 482.873 188.896C499.903 230.01 504.36 275.25 495.678 318.895C486.995 362.54 465.565 402.633 434.1 434.1C402.633 465.565 362.543 486.995 318.895 495.678C275.25 504.358 230.01 499.902 188.898 482.872C147.783 465.842 112.643 437.005 87.9199 400.002C63.1966 363.002 50.0004 319.5 50.0004 275C50.0004 215.328 73.7059 158.097 115.901 115.901C158.098 73.7053 215.328 50 275 50ZM50.0004 642.75V432C72.8921 464.743 102.643 492.103 137.183 512.178C171.723 532.255 210.22 544.563 250 548.25V592.75L50.0004 642.75ZM500 642.75L300 592.75V547.75C339.78 544.062 378.28 531.755 412.818 511.678C447.358 491.603 477.108 464.243 500 431.5V642.75Z"
          fill="#263238"
        />
      </svg>
    </>
  );
}

export function CalenderIcon(props) {
  return (
    <>
      <svg
        width="700"
        height="600"
        viewBox="0 0 700 600"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path
          d="M625 74.999H75C33.5788 74.999 0 108.578 0 149.999V525C0 566.42 33.5788 600 75 600H625C666.423 600 700 566.42 700 525V149.999C700 108.578 666.423 74.999 625 74.999Z"
          fill="#9FA8DA"
        />
        <path
          d="M700 149.999V200H25H0V149.999C0 130.108 7.90175 111.031 21.967 96.966C36.0322 82.9008 55.1087 74.999 75 74.999H625C644.89 74.999 663.967 82.9008 678.032 96.966C692.097 111.031 700 130.108 700 149.999Z"
          fill="#1A237E"
        />
        <path
          d="M225 124.999C218.37 124.999 212.01 122.365 207.323 117.677C202.635 112.988 200 106.63 200 99.999V49.999H150V99.999C150 106.63 147.366 112.988 142.678 117.677C137.989 122.365 131.63 124.999 125 124.999C118.37 124.999 112.011 122.365 107.322 117.677C102.634 112.988 100 106.63 100 99.999V24.999C100 18.3685 102.634 12.0098 107.322 7.32128C112.011 2.63303 118.37 -0.000976562 125 -0.000976562H225C231.63 -0.000976562 237.99 2.63303 242.677 7.32128C247.365 12.0098 250 18.3685 250 24.999V99.999C250 106.63 247.365 112.988 242.677 117.677C237.99 122.365 231.63 124.999 225 124.999Z"
          fill="#283593"
        />
        <path
          d="M575 124.999C568.37 124.999 562.01 122.365 557.323 117.677C552.635 112.988 550 106.63 550 99.999V49.999H500V99.999C500 106.63 497.365 112.988 492.677 117.677C487.99 122.365 481.63 124.999 475 124.999C468.37 124.999 462.01 122.365 457.323 117.677C452.635 112.988 450 106.63 450 99.999V24.999C450 18.3685 452.635 12.0098 457.323 7.32128C462.01 2.63303 468.37 -0.000976562 475 -0.000976562H575C581.63 -0.000976562 587.99 2.63303 592.677 7.32128C597.365 12.0098 600 18.3685 600 24.999V99.999C600 106.63 597.365 112.988 592.677 117.677C587.99 122.365 581.63 124.999 575 124.999Z"
          fill="#1A237E"
        />
        <path
          d="M175 425H150C136.193 425 125 436.193 125 450V475C125 488.807 136.193 500 150 500H175C188.807 500 200 488.807 200 475V450C200 436.193 188.807 425 175 425Z"
          fill="#0D47A1"
        />
        <path
          d="M300 300H275C261.193 300 250 311.193 250 325V350C250 363.807 261.193 375 275 375H300C313.807 375 325 363.807 325 350V325C325 311.193 313.807 300 300 300Z"
          fill="#0D47A1"
        />
        <path
          d="M300 425H275C261.193 425 250 436.193 250 450V475C250 488.807 261.193 500 275 500H300C313.807 500 325 488.807 325 475V450C325 436.193 313.807 425 300 425Z"
          fill="#0D47A1"
        />
        <path
          d="M425 300H400C386.193 300 375 311.193 375 325V350C375 363.807 386.193 375 400 375H425C438.807 375 450 363.807 450 350V325C450 311.193 438.807 300 425 300Z"
          fill="#0D47A1"
        />
        <path
          d="M425 425H400C386.193 425 375 436.193 375 450V475C375 488.807 386.193 500 400 500H425C438.807 500 450 488.807 450 475V450C450 436.193 438.807 425 425 425Z"
          fill="#0D47A1"
        />
        <path
          d="M550 300H525C511.193 300 500 311.193 500 325V350C500 363.807 511.193 375 525 375H550C563.807 375 575 363.807 575 350V325C575 311.193 563.807 300 550 300Z"
          fill="#C2185B"
        />
        <path
          d="M550 425H525C511.193 425 500 436.193 500 450V475C500 488.807 511.193 500 525 500H550C563.807 500 575 488.807 575 475V450C575 436.193 563.807 425 550 425Z"
          fill="#0D47A1"
        />
        <path
          d="M75 74.999C55.1087 74.999 36.0322 82.9008 21.967 96.966C7.90175 111.031 0 130.108 0 149.999V525C0 544.89 7.90175 563.967 21.967 578.032C36.0322 592.097 55.1087 600 75 600H350V74.999H75Z"
          fill="#C5CAE9"
        />
        <path
          d="M75 74.999C55.1087 74.999 36.0322 82.9008 21.967 96.966C7.90175 111.031 0 130.108 0 149.999V200H25H350V74.999H75Z"
          fill="#283593"
        />
        <path
          d="M225 124.999C218.37 124.999 212.01 122.365 207.323 117.677C202.635 112.988 200 106.63 200 99.999V49.999H150V99.999C150 106.63 147.366 112.988 142.678 117.677C137.989 122.365 131.63 124.999 125 124.999C118.37 124.999 112.011 122.365 107.322 117.677C102.634 112.988 100 106.63 100 99.999V24.999C100 18.3685 102.634 12.0098 107.322 7.32128C112.011 2.63303 118.37 -0.000976562 125 -0.000976562H225C231.63 -0.000976562 237.99 2.63303 242.677 7.32128C247.365 12.0098 250 18.3685 250 24.999V99.999C250 106.63 247.365 112.988 242.677 117.677C237.99 122.365 231.63 124.999 225 124.999Z"
          fill="#283593"
        />
        <path
          d="M175 425H150C136.193 425 125 436.193 125 450V475C125 488.807 136.193 500 150 500H175C188.807 500 200 488.807 200 475V450C200 436.193 188.807 425 175 425Z"
          fill="#EC407A"
        />
        <path
          d="M300 300H275C261.193 300 250 311.193 250 325V350C250 363.807 261.193 375 275 375H300C313.807 375 325 363.807 325 350V325C325 311.193 313.807 300 300 300Z"
          fill="#1565C0"
        />
        <path
          d="M300 425H275C261.193 425 250 436.193 250 450V475C250 488.807 261.193 500 275 500H300C313.807 500 325 488.807 325 475V450C325 436.193 313.807 425 300 425Z"
          fill="#1565C0"
        />
        <path
          d="M625 74.999H600V24.999C600 18.3685 597.365 12.0098 592.677 7.32128C587.99 2.63303 581.63 -0.000976562 575 -0.000976562H475C468.37 -0.000976562 462.01 2.63303 457.323 7.32128C452.635 12.0098 450 18.3685 450 24.999V74.999H250V24.999C250 18.3685 247.365 12.0098 242.677 7.32128C237.99 2.63303 231.63 -0.000976562 225 -0.000976562H125C118.37 -0.000976562 112.011 2.63303 107.322 7.32128C102.634 12.0098 100 18.3685 100 24.999V74.999H75C55.1087 74.999 36.0322 82.9008 21.967 96.966C7.90175 111.031 0 130.108 0 149.999V525C0 544.89 7.90175 563.967 21.967 578.032C36.0322 592.097 55.1087 600 75 600H625C644.89 600 663.967 592.097 678.032 578.032C692.097 563.967 700 544.89 700 525V149.999C700 130.108 692.097 111.031 678.032 96.966C663.967 82.9008 644.89 74.999 625 74.999ZM500 49.999H550V74.999H500V49.999ZM150 49.999H200V74.999H150V49.999ZM75 124.999H625C631.63 124.999 637.99 127.633 642.677 132.321C647.365 137.01 650 143.369 650 149.999V200H50V149.999C50 143.369 52.634 137.01 57.3223 132.321C62.0108 127.633 68.3695 124.999 75 124.999ZM625 550H75C68.3695 550 62.0108 547.364 57.3223 542.677C52.634 537.989 50 531.63 50 525V250H650V525C650 531.63 647.365 537.989 642.677 542.677C637.99 547.364 631.63 550 625 550Z"
          fill="#263238"
        />
        <path
          d="M625 74.999H75C33.5788 74.999 0 108.578 0 149.999V525C0 566.42 33.5788 600 75 600H625C666.423 600 700 566.42 700 525V149.999C700 108.578 666.423 74.999 625 74.999Z"
          fill="#589D8D"
        />
        <path
          d="M700 149.999V200H25H0V149.999C0 130.108 7.90175 111.031 21.967 96.966C36.0322 82.9008 55.1087 74.999 75 74.999H625C644.89 74.999 663.967 82.9008 678.032 96.966C692.097 111.031 700 130.108 700 149.999Z"
          fill="var(--primary)"
        />
        <path
          d="M225 124.999C218.37 124.999 212.01 122.365 207.323 117.677C202.635 112.988 200 106.63 200 99.999V49.999H150V99.999C150 106.63 147.366 112.988 142.678 117.677C137.989 122.365 131.63 124.999 125 124.999C118.37 124.999 112.011 122.365 107.322 117.677C102.634 112.988 100 106.63 100 99.999V24.999C100 18.3685 102.634 12.0098 107.322 7.32128C112.011 2.63303 118.37 -0.000976562 125 -0.000976562H225C231.63 -0.000976562 237.99 2.63303 242.677 7.32128C247.365 12.0098 250 18.3685 250 24.999V99.999C250 106.63 247.365 112.988 242.677 117.677C237.99 122.365 231.63 124.999 225 124.999Z"
          fill="#283593"
        />
        <path
          d="M575 124.999C568.37 124.999 562.01 122.365 557.323 117.677C552.635 112.988 550 106.63 550 99.999V49.999H500V99.999C500 106.63 497.365 112.988 492.677 117.677C487.99 122.365 481.63 124.999 475 124.999C468.37 124.999 462.01 122.365 457.323 117.677C452.635 112.988 450 106.63 450 99.999V24.999C450 18.3685 452.635 12.0098 457.323 7.32128C462.01 2.63303 468.37 -0.000976562 475 -0.000976562H575C581.63 -0.000976562 587.99 2.63303 592.677 7.32128C597.365 12.0098 600 18.3685 600 24.999V99.999C600 106.63 597.365 112.988 592.677 117.677C587.99 122.365 581.63 124.999 575 124.999Z"
          fill="#1A237E"
        />
        <path
          d="M175 425H150C136.193 425 125 436.193 125 450V475C125 488.807 136.193 500 150 500H175C188.807 500 200 488.807 200 475V450C200 436.193 188.807 425 175 425Z"
          fill="#0D47A1"
        />
        <path
          d="M300 300H275C261.193 300 250 311.193 250 325V350C250 363.807 261.193 375 275 375H300C313.807 375 325 363.807 325 350V325C325 311.193 313.807 300 300 300Z"
          fill="#0D47A1"
        />
        <path
          d="M300 425H275C261.193 425 250 436.193 250 450V475C250 488.807 261.193 500 275 500H300C313.807 500 325 488.807 325 475V450C325 436.193 313.807 425 300 425Z"
          fill="#0D47A1"
        />
        <path
          d="M425 300H400C386.193 300 375 311.193 375 325V350C375 363.807 386.193 375 400 375H425C438.807 375 450 363.807 450 350V325C450 311.193 438.807 300 425 300Z"
          fill="var(--primary)"
        />
        <path
          d="M425 425H400C386.193 425 375 436.193 375 450V475C375 488.807 386.193 500 400 500H425C438.807 500 450 488.807 450 475V450C450 436.193 438.807 425 425 425Z"
          fill="var(--primary)"
        />
        <path
          d="M550 300H525C511.193 300 500 311.193 500 325V350C500 363.807 511.193 375 525 375H550C563.807 375 575 363.807 575 350V325C575 311.193 563.807 300 550 300Z"
          fill="var(--accent)"
        />
        <path
          d="M550 425H525C511.193 425 500 436.193 500 450V475C500 488.807 511.193 500 525 500H550C563.807 500 575 488.807 575 475V450C575 436.193 563.807 425 550 425Z"
          fill="var(--primary)"
        />
        <path
          d="M75 74.999C55.1087 74.999 36.0322 82.9008 21.967 96.966C7.90175 111.031 0 130.108 0 149.999V525C0 544.89 7.90175 563.967 21.967 578.032C36.0322 592.097 55.1087 600 75 600H350V74.999H75Z"
          fill="#AAC9B9"
        />
        <path
          d="M75 74.999C55.1087 74.999 36.0322 82.9008 21.967 96.966C7.90175 111.031 0 130.108 0 149.999V200H25H350V74.999H75Z"
          fill="var(--secondary)"
        />
        <path
          d="M225 124.999C218.37 124.999 212.01 122.365 207.323 117.677C202.635 112.988 200 106.63 200 99.999V49.999H150V99.999C150 106.63 147.366 112.988 142.678 117.677C137.989 122.365 131.63 124.999 125 124.999C118.37 124.999 112.011 122.365 107.322 117.677C102.634 112.988 100 106.63 100 99.999V24.999C100 18.3685 102.634 12.0098 107.322 7.32128C112.011 2.63303 118.37 -0.000976562 125 -0.000976562H225C231.63 -0.000976562 237.99 2.63303 242.677 7.32128C247.365 12.0098 250 18.3685 250 24.999V99.999C250 106.63 247.365 112.988 242.677 117.677C237.99 122.365 231.63 124.999 225 124.999Z"
          fill="#283593"
        />
        <path
          d="M175 425H150C136.193 425 125 436.193 125 450V475C125 488.807 136.193 500 150 500H175C188.807 500 200 488.807 200 475V450C200 436.193 188.807 425 175 425Z"
          fill="var(--accent)"
        />
        <path
          d="M300 300H275C261.193 300 250 311.193 250 325V350C250 363.807 261.193 375 275 375H300C313.807 375 325 363.807 325 350V325C325 311.193 313.807 300 300 300Z"
          fill="var(--primary)"
        />
        <path
          d="M300 425H275C261.193 425 250 436.193 250 450V475C250 488.807 261.193 500 275 500H300C313.807 500 325 488.807 325 475V450C325 436.193 313.807 425 300 425Z"
          fill="var(--primary)"
        />
        <path
          d="M625 74.999H600V24.999C600 18.3685 597.365 12.0098 592.677 7.32128C587.99 2.63303 581.63 -0.000976562 575 -0.000976562H475C468.37 -0.000976562 462.01 2.63303 457.323 7.32128C452.635 12.0098 450 18.3685 450 24.999V74.999H250V24.999C250 18.3685 247.365 12.0098 242.677 7.32128C237.99 2.63303 231.63 -0.000976562 225 -0.000976562H125C118.37 -0.000976562 112.011 2.63303 107.322 7.32128C102.634 12.0098 100 18.3685 100 24.999V74.999H75C55.1087 74.999 36.0322 82.9008 21.967 96.966C7.90175 111.031 0 130.108 0 149.999V525C0 544.89 7.90175 563.967 21.967 578.032C36.0322 592.097 55.1087 600 75 600H625C644.89 600 663.967 592.097 678.032 578.032C692.097 563.967 700 544.89 700 525V149.999C700 130.108 692.097 111.031 678.032 96.966C663.967 82.9008 644.89 74.999 625 74.999ZM500 49.999H550V74.999H500V49.999ZM150 49.999H200V74.999H150V49.999ZM75 124.999H625C631.63 124.999 637.99 127.633 642.677 132.321C647.365 137.01 650 143.369 650 149.999V200H50V149.999C50 143.369 52.634 137.01 57.3223 132.321C62.0108 127.633 68.3695 124.999 75 124.999ZM625 550H75C68.3695 550 62.0108 547.364 57.3223 542.677C52.634 537.989 50 531.63 50 525V250H650V525C650 531.63 647.365 537.989 642.677 542.677C637.99 547.364 631.63 550 625 550Z"
          fill="#263238"
        />
      </svg>
    </>
  );
}

export function QuizIcon(props) {
  return (
    <>
      <svg
        width="500"
        height="701"
        viewBox="0 0 500 701"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path
          d="M425 0.25H75C33.5788 0.25 0 33.8287 0 75.25V625.25C0 666.672 33.5788 700.25 75 700.25H425C466.423 700.25 500 666.672 500 625.25V75.25C500 33.8287 466.423 0.25 425 0.25Z"
          fill="#CFD8DC"
        />
        <path
          d="M375 599.998C371.71 600.018 368.447 599.388 365.402 598.143C362.357 596.9 359.585 595.065 357.25 592.748L282.25 517.748C277.592 513.065 274.98 506.728 274.98 500.123C274.98 493.52 277.592 487.183 282.25 482.498C284.575 480.155 287.34 478.295 290.385 477.028C293.432 475.758 296.7 475.105 300 475.105C303.3 475.105 306.567 475.758 309.615 477.028C312.66 478.295 315.425 480.155 317.75 482.498L392.75 557.498C395.092 559.823 396.952 562.588 398.222 565.635C399.492 568.68 400.145 571.948 400.145 575.248C400.145 578.55 399.492 581.818 398.222 584.863C396.952 587.91 395.092 590.675 392.75 592.998C387.992 597.588 381.61 600.105 375 599.998Z"
          fill="#E53935"
        />
        <path
          d="M300 599.998C296.71 600.018 293.447 599.388 290.402 598.143C287.357 596.898 284.585 595.065 282.25 592.748C279.908 590.425 278.047 587.66 276.777 584.613C275.507 581.568 274.855 578.3 274.855 574.998C274.855 571.698 275.507 568.43 276.777 565.385C278.047 562.338 279.908 559.573 282.25 557.248L357.25 482.248C359.575 479.905 362.34 478.045 365.385 476.775C368.432 475.508 371.7 474.853 375 474.853C378.3 474.853 381.567 475.508 384.615 476.775C387.66 478.045 390.425 479.905 392.75 482.248C397.407 486.933 400.02 493.27 400.02 499.873C400.02 506.478 397.407 512.815 392.75 517.498L317.75 592.498C315.435 594.86 312.672 596.74 309.627 598.028C306.58 599.315 303.307 599.985 300 599.998Z"
          fill="#E53935"
        />
        <path
          d="M150 600H148.5C144.073 599.74 139.795 598.305 136.105 595.845C132.413 593.385 129.445 589.987 127.5 586L102.5 536C99.7883 530.097 99.4813 523.37 101.645 517.242C103.808 511.117 108.27 506.072 114.088 503.18C119.905 500.287 126.62 499.775 132.81 501.747C139 503.72 144.18 508.025 147.25 513.75L153 525.25L179.25 486C183.093 480.895 188.743 477.452 195.043 476.382C201.343 475.312 207.813 476.695 213.125 480.247C218.438 483.797 222.188 489.25 223.608 495.482C225.025 501.712 224.003 508.25 220.75 513.75L170.75 588.75C168.485 592.19 165.408 595.017 161.788 596.98C158.168 598.942 154.118 599.98 150 600Z"
          fill="#689F38"
        />
        <path d="M500 375.25H0V425.25H500V375.25Z" fill="#304046" />
        <path
          d="M200 225H125C118.37 225 112.01 222.365 107.323 217.677C102.635 212.99 100 206.63 100 200V125C100 118.37 102.635 112.011 107.323 107.322C112.01 102.634 118.37 100 125 100H200C206.63 100 212.99 102.634 217.677 107.322C222.365 112.011 225 118.37 225 125V200C225 206.63 222.365 212.99 217.677 217.677C212.99 222.365 206.63 225 200 225ZM150 175H175V150H150V175Z"
          fill="var(--accent)"
        />
        <path
          d="M375 325H125C118.37 325 112.01 322.365 107.323 317.677C102.635 312.99 100 306.63 100 300C100 293.37 102.635 287.01 107.323 282.323C112.01 277.635 118.37 275 125 275H375C381.63 275 387.99 277.635 392.677 282.323C397.365 287.01 400 293.37 400 300C400 306.63 397.365 312.99 392.677 317.677C387.99 322.365 381.63 325 375 325Z"
          fill="#304046"
        />
        <path
          d="M375 150H300C293.37 150 287.01 147.366 282.323 142.678C277.635 137.989 275 131.63 275 125C275 118.37 277.635 112.011 282.323 107.322C287.01 102.634 293.37 100 300 100H375C381.63 100 387.99 102.634 392.677 107.322C397.365 112.011 400 118.37 400 125C400 131.63 397.365 137.989 392.677 142.678C387.99 147.366 381.63 150 375 150Z"
          fill="#304046"
        />
        <path
          d="M375 225H300C293.37 225 287.01 222.365 282.323 217.677C277.635 212.99 275 206.63 275 200C275 193.37 277.635 187.011 282.323 182.322C287.01 177.634 293.37 175 300 175H375C381.63 175 387.99 177.634 392.677 182.322C397.365 187.011 400 193.37 400 200C400 206.63 397.365 212.99 392.677 217.677C387.99 222.365 381.63 225 375 225Z"
          fill="#304046"
        />
        <path
          d="M75 0C55.1087 0 36.0323 7.90175 21.967 21.967C7.90176 36.0322 0 55.1087 0 75V625C0 644.89 7.90176 663.967 21.967 678.032C36.0323 692.097 55.1087 700 75 700H250V0H75Z"
          fill="#EEEEEE"
        />
        <path
          d="M179.25 486.25L153 525L147.25 513.5C144.18 507.775 139 503.47 132.81 501.497C126.62 499.522 119.905 500.037 114.088 502.93C108.27 505.822 103.808 510.867 101.645 516.992C99.4813 523.12 99.7883 529.847 102.5 535.75L127.5 585.75C129.445 589.737 132.413 593.135 136.105 595.595C139.795 598.055 144.073 599.49 148.5 599.75H150C154.118 599.73 158.168 598.692 161.788 596.73C165.408 594.767 168.485 591.94 170.75 588.5L220.75 513.5C224.003 508 225.025 501.462 223.608 495.23C222.188 489 218.438 483.547 213.125 479.997C207.813 476.445 201.343 475.06 195.043 476.132C188.743 477.202 183.093 480.645 179.25 485.75V486.25Z"
          fill="#689F38"
        />
        <path d="M250 375.25H0V425.25H250V375.25Z" fill="#616161" />
        <path
          d="M200 225H125C118.37 225 112.01 222.365 107.323 217.677C102.635 212.99 100 206.63 100 200V125C100 118.37 102.635 112.011 107.323 107.322C112.01 102.634 118.37 100 125 100H200C206.63 100 212.99 102.634 217.677 107.322C222.365 112.011 225 118.37 225 125V200C225 206.63 222.365 212.99 217.677 217.677C212.99 222.365 206.63 225 200 225ZM150 175H175V150H150V175Z"
          fill="var(--accent)"
        />
        <path
          d="M125 275C118.37 275 112.01 277.635 107.323 282.323C102.635 287.01 100 293.37 100 300C100 306.63 102.635 312.99 107.323 317.677C112.01 322.365 118.37 325 125 325H250V275H125Z"
          fill="#616161"
        />
        <path
          d="M425 0H75C55.1087 0 36.0323 7.90175 21.967 21.967C7.90176 36.0322 0 55.1087 0 75V625C0 644.89 7.90176 663.967 21.967 678.032C36.0323 692.097 55.1087 700 75 700H425C444.89 700 463.967 692.097 478.032 678.032C492.097 663.967 500 644.89 500 625V75C500 55.1087 492.097 36.0322 478.032 21.967C463.967 7.90175 444.89 0 425 0ZM450 625C450 631.63 447.365 637.99 442.677 642.677C437.99 647.365 431.63 650 425 650H75C68.3695 650 62.0107 647.365 57.3222 642.677C52.634 637.99 50 631.63 50 625V75C50 68.3695 52.634 62.0108 57.3222 57.3223C62.0107 52.634 68.3695 50 75 50H425C431.63 50 437.99 52.634 442.677 57.3223C447.365 62.0108 450 68.3695 450 75V625Z"
          fill="#263238"
        />
      </svg>
    </>
  );
}

export function InstructionsIcon(props) {
  return (
    <>
      <svg
        width="700"
        height="500"
        viewBox="0 0 700 500"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path
          d="M625 0H75C33.5788 0 0 33.5788 0 75V425C0 466.423 33.5788 500 75 500H625C666.423 500 700 466.423 700 425V75C700 33.5788 666.423 0 625 0Z"
          fill="var(--primary)"
        />
        <path
          d="M350 0V500H75C55.1087 500 36.0322 492.097 21.967 478.032C7.90175 463.967 0 444.89 0 425V75C0 55.1087 7.90175 36.0323 21.967 21.967C36.0322 7.90176 55.1087 0 75 0H350Z"
          fill="var(--secondary)"
        />
        <path
          d="M250 0V350C250 356.63 247.365 362.99 242.677 367.677C237.99 372.365 231.63 375 225 375C218.37 375 212.01 372.365 207.323 367.677C202.635 362.99 200 356.63 200 350V0H250Z"
          fill="#F5F5F5"
        />
        <path
          d="M575 175H450C443.37 175 437.01 172.365 432.323 167.677C427.635 162.99 425 156.63 425 150C425 143.37 427.635 137.01 432.323 132.323C437.01 127.635 443.37 125 450 125H575C581.63 125 587.99 127.635 592.677 132.323C597.365 137.01 600 143.37 600 150C600 156.63 597.365 162.99 592.677 167.677C587.99 172.365 581.63 175 575 175Z"
          fill="#E0E0E0"
        />
        <path
          d="M575 275H500C493.37 275 487.01 272.365 482.323 267.677C477.635 262.99 475 256.63 475 250C475 243.37 477.635 237.01 482.323 232.323C487.01 227.635 493.37 225 500 225H575C581.63 225 587.99 227.635 592.677 232.323C597.365 237.01 600 243.37 600 250C600 256.63 597.365 262.99 592.677 267.677C587.99 272.365 581.63 275 575 275Z"
          fill="#E0E0E0"
        />
        <path
          d="M575 375H450C443.37 375 437.01 372.365 432.323 367.677C427.635 362.99 425 356.63 425 350C425 343.37 427.635 337.01 432.323 332.323C437.01 327.635 443.37 325 450 325H575C581.63 325 587.99 327.635 592.677 332.323C597.365 337.01 600 343.37 600 350C600 356.63 597.365 362.99 592.677 367.677C587.99 372.365 581.63 375 575 375Z"
          fill="#E0E0E0"
        />
        <path
          d="M625 0H75C55.1087 0 36.0322 7.90176 21.967 21.967C7.90175 36.0323 0 55.1087 0 75V425C0 444.89 7.90175 463.967 21.967 478.032C36.0322 492.097 55.1087 500 75 500H625C644.89 500 663.967 492.097 678.032 478.032C692.097 463.967 700 444.89 700 425V75C700 55.1087 692.097 36.0323 678.032 21.967C663.967 7.90176 644.89 0 625 0ZM50 425V75C50 68.3695 52.634 62.0107 57.3223 57.3222C62.0108 52.634 68.3695 50 75 50H325V450H75C68.3695 450 62.0108 447.365 57.3223 442.677C52.634 437.99 50 431.63 50 425ZM650 425C650 431.63 647.365 437.99 642.677 442.677C637.99 447.365 631.63 450 625 450H375V50H625C631.63 50 637.99 52.634 642.677 57.3222C647.365 62.0107 650 68.3695 650 75V425Z"
          fill="#263238"
        />
      </svg>
    </>
  );
}

export function UmbrellaMemberIcon(props) {
  return (
    <>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path
          d="M25 0H3C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H25C26.6569 20 28 18.6569 28 17V3C28 1.34315 26.6569 0 25 0Z"
          fill="var(--primary)"
        />
        <path
          d="M12.09 9.15025C12.5183 8.73425 12.8128 8.19995 12.9357 7.61563C13.0587 7.03133 13.0044 6.42364 12.78 5.87035C12.5555 5.31705 12.1711 4.84331 11.6758 4.50977C11.1806 4.17623 10.5971 3.99805 10 3.99805C9.4029 3.99805 8.8194 4.17623 8.3242 4.50977C7.82892 4.84331 7.44447 5.31705 7.22002 5.87035C6.99557 6.42364 6.94134 7.03133 7.06426 7.61563C7.18717 8.19995 7.48165 8.73425 7.91 9.15025C5.68 9.75025 4 12.1402 4 15.0002C4 15.2654 4.10536 15.5198 4.29289 15.7073C4.48043 15.8948 4.73478 16.0002 5 16.0002C5.26522 16.0002 5.51957 15.8948 5.70711 15.7073C5.89464 15.5198 6 15.2654 6 15.0002C6 12.7902 7.35 11.0002 9 11.0002H11C12.65 11.0002 14 12.7902 14 15.0002C14 15.2654 14.1054 15.5198 14.2929 15.7073C14.4804 15.8948 14.7348 16.0002 15 16.0002C15.2652 16.0002 15.5196 15.8948 15.7071 15.7073C15.8946 15.5198 16 15.2654 16 15.0002C16 12.1402 14.32 9.75025 12.09 9.15025ZM10 6.00024C10.1978 6.00024 10.3911 6.05889 10.5556 6.16877C10.72 6.27865 10.8482 6.43483 10.9239 6.61755C10.9996 6.80028 11.0194 7.00135 10.9808 7.19533C10.9422 7.38931 10.847 7.56749 10.7071 7.70734C10.5673 7.8472 10.3891 7.94244 10.1951 7.98102C10.0011 8.01965 9.8 7.9998 9.6173 7.92412C9.4346 7.84843 9.2784 7.72026 9.1685 7.55581C9.0586 7.39136 9 7.19802 9 7.00024C9 6.73502 9.1054 6.48067 9.2929 6.29313C9.4804 6.10559 9.7348 6.00024 10 6.00024Z"
          fill="var(--accent)"
        />
        <path
          d="M23 6H20C19.7348 6 19.4804 5.89464 19.2929 5.70711C19.1054 5.51957 19 5.26522 19 5C19 4.73478 19.1054 4.48043 19.2929 4.29289C19.4804 4.10536 19.7348 4 20 4H23C23.2652 4 23.5196 4.10536 23.7071 4.29289C23.8946 4.48043 24 4.73478 24 5C24 5.26522 23.8946 5.51957 23.7071 5.70711C23.5196 5.89464 23.2652 6 23 6Z"
          fill="#E0E0E0"
        />
        <path
          d="M23 10H17C16.7348 10 16.4804 9.8946 16.2929 9.7071C16.1054 9.5196 16 9.2652 16 9C16 8.7348 16.1054 8.4804 16.2929 8.2929C16.4804 8.1054 16.7348 8 17 8H23C23.2652 8 23.5196 8.1054 23.7071 8.2929C23.8946 8.4804 24 8.7348 24 9C24 9.2652 23.8946 9.5196 23.7071 9.7071C23.5196 9.8946 23.2652 10 23 10Z"
          fill="#E0E0E0"
        />
        <path
          d="M23 14H20C19.7348 14 19.4804 13.8946 19.2929 13.7071C19.1054 13.5196 19 13.2652 19 13C19 12.7348 19.1054 12.4804 19.2929 12.2929C19.4804 12.1054 19.7348 12 20 12H23C23.2652 12 23.5196 12.1054 23.7071 12.2929C23.8946 12.4804 24 12.7348 24 13C24 13.2652 23.8946 13.5196 23.7071 13.7071C23.5196 13.8946 23.2652 14 23 14Z"
          fill="#E0E0E0"
        />
        <path
          d="M25 22H3C2.20435 22 1.44129 22.3161 0.87868 22.8787C0.31607 23.4413 0 24.2044 0 25C0 25.7956 0.31607 26.5587 0.87868 27.1213C1.44129 27.6839 2.20435 28 3 28H25C25.7956 28 26.5587 27.6839 27.1213 27.1213C27.6839 26.5587 28 25.7956 28 25C28 24.2044 27.6839 23.4413 27.1213 22.8787C26.5587 22.3161 25.7956 22 25 22Z"
          fill="#37474F"
        />
        <path
          d="M3 0C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3V17C0 17.7956 0.31607 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H14V0H3Z"
          fill="var(--secondary)"
        />
        <path
          d="M12.09 9.15025C12.5183 8.73425 12.8128 8.19995 12.9357 7.61563C13.0587 7.03133 13.0044 6.42364 12.78 5.87035C12.5555 5.31705 12.1711 4.84331 11.6758 4.50977C11.1806 4.17623 10.5971 3.99805 10 3.99805C9.4029 3.99805 8.8194 4.17623 8.3242 4.50977C7.82892 4.84331 7.44447 5.31705 7.22002 5.87035C6.99557 6.42364 6.94134 7.03133 7.06426 7.61563C7.18717 8.19995 7.48165 8.73425 7.91 9.15025C5.68 9.75025 4 12.1402 4 15.0002C4 15.2654 4.10536 15.5198 4.29289 15.7073C4.48043 15.8948 4.73478 16.0002 5 16.0002C5.26522 16.0002 5.51957 15.8948 5.70711 15.7073C5.89464 15.5198 6 15.2654 6 15.0002C6 12.7902 7.35 11.0002 9 11.0002H11C12.65 11.0002 14 12.7902 14 15.0002V10.2302C13.4593 9.72205 12.8042 9.35165 12.09 9.15025ZM10 8.00024C9.8022 8.00024 9.6089 7.94159 9.4444 7.83171C9.28 7.72183 9.1518 7.56565 9.0761 7.38292C9.0004 7.2002 8.9806 6.99913 9.0192 6.80515C9.0578 6.61117 9.153 6.43298 9.2929 6.29313C9.4327 6.15328 9.6109 6.05804 9.8049 6.01945C9.9989 5.98087 10.2 6.00067 10.3827 6.07636C10.5654 6.15205 10.7216 6.28022 10.8315 6.44467C10.9414 6.60912 11 6.80246 11 7.00024C11 7.26545 10.8946 7.51981 10.7071 7.70734C10.5196 7.89488 10.2652 8.00024 10 8.00024Z"
          fill="#D8CD9B"
        />
        <path
          d="M3 22C2.20435 22 1.44129 22.3161 0.87868 22.8787C0.31607 23.4413 0 24.2044 0 25C0 25.7956 0.31607 26.5587 0.87868 27.1213C1.44129 27.6839 2.20435 28 3 28H14V22H3Z"
          fill="#455A64"
        />
        <path
          d="M25 0H3C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3V17C0 17.7956 0.31607 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H25C25.7956 20 26.5587 19.6839 27.1213 19.1213C27.6839 18.5587 28 17.7956 28 17V3C28 2.20435 27.6839 1.44129 27.1213 0.87868C26.5587 0.31607 25.7956 0 25 0ZM26 17C26 17.2652 25.8946 17.5196 25.7071 17.7071C25.5196 17.8946 25.2652 18 25 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H25C25.2652 2 25.5196 2.10536 25.7071 2.29289C25.8946 2.48043 26 2.73478 26 3V17Z"
          fill="#263238"
        />
        <path
          d="M25 22H3C2.20435 22 1.44129 22.3161 0.87868 22.8787C0.31607 23.4413 0 24.2044 0 25C0 25.7956 0.31607 26.5587 0.87868 27.1213C1.44129 27.6839 2.20435 28 3 28H25C25.7956 28 26.5587 27.6839 27.1213 27.1213C27.6839 26.5587 28 25.7956 28 25C28 24.2044 27.6839 23.4413 27.1213 22.8787C26.5587 22.3161 25.7956 22 25 22ZM25 26H3C2.73478 26 2.48043 25.8946 2.29289 25.7071C2.10536 25.5196 2 25.2652 2 25C2 24.7348 2.10536 24.4804 2.29289 24.2929C2.48043 24.1054 2.73478 24 3 24H25C25.2652 24 25.5196 24.1054 25.7071 24.2929C25.8946 24.4804 26 24.7348 26 25C26 25.2652 25.8946 25.5196 25.7071 25.7071C25.5196 25.8946 25.2652 26 25 26Z"
          fill="#263238"
        />
      </svg>
    </>
  );
}

export function RoleManagementIcon(props) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        className={props.className}
        onClick={props.onClick}
        onClose={props.onClose}
      >
        <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H362.3c-5.3-12.2-8.3-25.7-8.3-40V396.3c0-38.3 22.3-71.3 54.8-87.1c-29.1-3.4-58.8-5.2-89.1-5.2H178.3zm354.3-32c-39.8 0-72 32.2-72 72v24H448c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32h-12.6v-24c0-39.8-32.2-72-72-72zm40 96H522.6v-24c0-22.1 17.9-40 40-40s40 17.9 40 40v24z" />
      </svg>
    </>
  );
}
